import React from 'react';
import {KTMScreen,ActionEvent,RenderEvent,renderScreen, FilterBox} from 'ktm-ui';
import {KTMApi} from 'api/KTMApi';
import {Layout,Dialog,DataGrid,IDataGridLayout,Display,Button,Line,Card} from 'ktm-ui';

interface IdsTaxJurisdictions {
    Id:string;
    Name:string;
};

export default KTMScreen({name:"planadmin.lookups.tax-jurisdiction"}, class extends React.Component<{keyword?:string,eventValue?:string}> {

    data:{
        dsTaxJurisdictions:IdsTaxJurisdictions;
    }

    render(){
        return renderScreen(this);
    }

    async start({screen}:ActionEvent){
        screen.defaultRecord = "@dsTaxJurisdictions";
        await KTMApi.start(screen,{
            "@keyword":this.props.keyword
        });
        screen.onEnterKey = this.search;
        screen.title = "Tax jurisidiction lookup";
    }

    main({field,draw,action}:RenderEvent){
        return (
            <Layout  dialogSize="medium" dialogHeight="medium" padding="none">
                {draw(this.header)}
                {draw(this.search_panel)}
                {draw(this.default_view)}
                {draw(this.footer)}
            </Layout>
        );
    }

    header({field,draw,action}:RenderEvent){
        return (
            <Dialog.Header label="Tax jurisdictions lookup">
            </Dialog.Header>
        );
    }

    default_view({field,draw,action,collection}:RenderEvent){
        let actions = null;
        let layout:IDataGridLayout = {
            columns:[
                {name:"Id",label:"Id",type:"character"},
                {name:"Name",label:"Name",type:"character",width:339},
            ],
            sort:[{name:"Id"}]
        };
        return (
            <DataGrid collection={collection("@dsTaxJurisdictions")} layout={layout} actions={actions} onRowClick={action(this.on_row_click)}/>
        );
    }

    search_panel({field,draw,action}:RenderEvent){
        return (
            <Card>
                <Line>
                    <FilterBox field={field("@keyword")}/>
                    <Button action={action(this.search)} label="Search" style="primary"/>
                </Line>
            </Card>
        );
    }

    footer({field,draw,action}:RenderEvent){
        return (
            <Dialog.Footer>
            </Dialog.Footer>
        );
    }

    async search({screen}:ActionEvent){
        await KTMApi.action(screen,"search",{
            "@keyword":screen.getFilter('@keyword')
        });
    }

    async on_row_click({screen}:ActionEvent){
        screen.close({continue:true,value:screen.getValue("Id"),label:screen.getValue("Name")});
    }

});
